export default __webpack_public_path__ + "static/intercomlogo-bb9260c1904e97586ccbf70c911e026a.svg";